import { Card, CardHeader } from '@material-ui/core'
import React from 'react'
import ActionBar from '../../ActionBar/ActionBar'
import NoDataDisplay from '../../NoDataDisplay/NoDataDisplay'
import PageInfo from '../../PageInfo/PageInfo'
import PleaseFilter from '../../PleaseFilter/PleaseFilter'
import Spinner from '../../UI/Spinner/Spinner'
import FeedbackPanel from './FeedbackPanel/FeedbackPanel'

const FeedbackContent = ({
  pageTranslateKey,
  filtered,
  filterClicked,
  empList,
  structureList,
  userClicked,
  selectedEmpId,
  itemExpanded,
  chatHistory,
  onFeedbackSubmit,
  onFeedbackFileClick,
  onFeedbackScroll,
  loadingStates,
  isAdmin
}) => {
  let content = <PleaseFilter />

  if (loadingStates.includes('feedbackEmp')) {
    content = <Spinner />
  } else if (filtered) {
    if (!empList.length) {
      content = <NoDataDisplay />
    } else {
      content = (
        <FeedbackPanel
          empList={empList}
          userClicked={userClicked}
          selectedEmpId={selectedEmpId}
          structureList={structureList}
          itemExpanded={itemExpanded}
          chatHistory={chatHistory}
          onFeedbackSubmit={onFeedbackSubmit}
          onFeedbackFileClick={onFeedbackFileClick}
          onFeedbackScroll={onFeedbackScroll}
          loadingStates={loadingStates}
          isAdmin={isAdmin}
        />
      )
    }
  }

  const pageTitle = (
    <ActionBar
      show={['filter']}
      filtering={filterClicked}
      leftContent={<PageInfo pageTranslateKey={pageTranslateKey} />}
    />
  )

  return (
    <Card>
      <CardHeader title={pageTitle} />
      {content}
    </Card>
  )
}

export default FeedbackContent
